import React from 'react';
import { motion } from 'framer-motion';
import styles from './Hero.module.css';
import myLogo from '../../aryannlogo.png';
import { Canvas } from '@react-three/fiber';


function Hero() {
    // Animation variants for text and Enigma
    const textVariant = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 },
    };

    const enigmaVariant = {
        hidden: { opacity: 0, scale: 0.8 },
        visible: { opacity: 1, scale: 1 },
    };

    return (
        <div>
            <header className={`h-full lg:h-dvh bg-gray-900 ${styles.pattern}`}>
                <div className="container px-6 mx-auto h-[100%]">
                    <motion.nav
                        className="flex flex-col py-6 sm:flex-row sm:justify-between sm:items-center"
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <a href="#">
                            <img className="w-auto h-6 sm:h-7" src={myLogo} alt="" />
                        </a>

                        <div className="flex items-center mt-2 -mx-2 sm:mt-0">
                            <a href="#experience" className="px-3 py-1 text-sm font-semibold text-white transition-colors duration-300 transform border-2 rounded-md hover:bg-gray-700">
                                Experience
                            </a>
                            <a href="#blog" className="px-3 py-2 mx-2 text-sm font-semibold text-white transition-colors duration-300 transform bg-black rounded-md hover:bg-gray-800">
                                Blog
                            </a>
                        </div>
                    </motion.nav>

                    <div className="flex flex-col items-center py-6 lg:h-[80%] lg:flex-row">
                        <motion.div
                            className="lg:w-1/2"
                            variants={textVariant}
                            initial="hidden"
                            animate="visible"
                            transition={{ duration: 0.8, delay: 0.2 }}
                        >
                            <svg
                                className="w-8 h-8 text-gray-400 dark:text-gray-600 mb-4"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 18 14"
                            >
                                <path d="M6 0H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3H2a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Zm10 0h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3h-1a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Z" />
                            </svg>

                            <p className="mt-4 text-2xl font-semibold lg:text-2xl text-gray-400">
                                Crafting Digital Experiences Innovatively.
                            </p>

                            <h2 className="text-5xl font-semibold text-gray-100 lg:text-6xl">
                                Aryann <span className="text-blue-400">Dwivedi.</span>
                            </h2>
                        </motion.div>
                        <motion.div
                            className="lg:w-1/2"
                            variants={textVariant}
                            initial="hidden"
                            animate="visible"
                            transition={{ duration: 0.8, delay: 0.2 }}
                        >
                            <svg
                                className="w-8 h-8 text-gray-400 dark:text-gray-600 mb-4"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 18 14"
                            >
                                <path d="M6 0H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3H2a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Zm10 0h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3h-1a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Z" />
                            </svg>

                            
                        </motion.div>
                    </div>
                </div>
            </header>
        </div>
    );
}

export default Hero;